import * as z from 'zod';

// A regular expression for a stricter domain name
const domainRegex = /^((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,6}$/;

// Schema using a custom regex with refine()
const customDomainSchema = z.string().refine((value) => domainRegex.test(value), {
  message: 'Invalid domain name',
});

// // This will pass
// customDomainSchema.parse('example.com');

export const domainQueryLinkerSchemaWithExData = z.object({
  id: z.number(),
  name: customDomainSchema,
  dns_management: z.string().nullable(),
  deployment_path: z.string().nullable(),
});

export type DomainQueryLinkerSchemaWithExData = z.infer<typeof domainQueryLinkerSchemaWithExData>;

export const domainQueryLinkerSchema = domainQueryLinkerSchemaWithExData.pick({
  id: true,
  name: true,
});

export type DomainQueryLinkerSchema = z.infer<typeof domainQueryLinkerSchema>;
